import React, { useState } from "react";
import "../../App.css";
import kitchensBasketData from "./data/kitchensBasketData";
import { FiPhone } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";

const KitchensBasket = () => {
  const phone = "919650100908";

  const [selectedImage, setSelectedImage] = useState(null);
const [previewImage, setPreviewImage] = useState(null);
  const handleWhatsApp = (productName) => {
    const message = `Hello, I am interested in ${productName}`;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const handleCall = () => {
    window.location.href = `tel:+${phone}`;
  };

  const getYouTubeWatchUrl = (embedUrl) => {
    if (!embedUrl) return "#";
    const videoId = embedUrl.split("/embed/")[1];
    return `https://www.youtube.com/watch?v=${videoId}`;
  };

  return (
    <div className="basket-page">
      {/* HERO */}
      <div className="basket-hero">
        <h2>
          Kitchen Baskets – Organize, Store & Beautify Your <br />
          Modular Kitchen
        </h2>

        <p>
          Stylish, durable & space-saving kitchen storage solutions for modern
          homes.
        </p>

        <div className="hero-btn-group">
          <button className="hero-btn" onClick={handleCall}>
            <FiPhone /> Get Best Price
          </button>

          <button
            className="hero-btn whatsapp"
            onClick={() => handleWhatsApp("Kitchen Basket")}
          >
            <FaWhatsapp /> WhatsApp
          </button>
        </div>
      </div>

      {/* FEATURES */}
      <div className="features">
        <h2>Why Choose Our Kitchen Baskets?</h2>

        <div className="features-grid">
          <div className="feature-box">✔ Rust Resistant</div>
          <div className="feature-box">✔ Smooth Sliding</div>
          <div className="feature-box">✔ Space Saving</div>
          <div className="feature-box">✔ Long Lasting</div>
        </div>
      </div>

      {/* PRODUCTS */}
      <div className="basket-container">
        {kitchensBasketData.map((item) => (
          <div className="basket-card" key={item.id}>
            <img
              src={item.image}
              alt={item.name + " modular kitchen basket"}
              loading="lazy"
              className="basket-image"
              onClick={() => setSelectedImage(item.image)}
            />

            <h3>{item.name}</h3>

            {item.price && (
              <div className="price-box">
                <span className="price">{item.price}</span>

                {item.oldPrice && (
                  <span className="old-price">{item.oldPrice}</span>
                )}
              </div>
            )}

            <p>{item.description}</p>

            {item.video && (
              <div className="product-video">
                <iframe
                  width="100%"
                  height="200"
                  src={item.video}
                  title="Product Video"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
            )}

            <div className="btn-group">
              <button className="call-btn" onClick={handleCall}>
                <FiPhone /> Call
              </button>

              <button
                className="whatsapp-btn"
                onClick={() => handleWhatsApp(item.name)}
              >
                <FaWhatsapp /> WhatsApp
              </button>

              {item.video && (
                <a
                  href={getYouTubeWatchUrl(item.video)}
                  target="_blank"
                  rel="noreferrer"
                  className="watch-btn"
                >
                  ▶ Watch
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* IMAGE MODAL */}
      {selectedImage && (
        <div
          className="image-modal"
          onClick={() => setSelectedImage(null)}
        >
          <span
            className="close-btn"
            onClick={() => setSelectedImage(null)}
          >
            ✕
          </span>

          <img
            src={selectedImage}
            alt="Preview"
            className="modal-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default KitchensBasket;